import AxiosConfig from '../config/axiosConfigApiPlataform'

export const EmpresaApi = {
  pegaConfiguracaoWL (subdominio) {
    return AxiosConfig.api().get(`empresas/configuracoes-wls/${subdominio}`).then(response => response.data)
  }
}

export default EmpresaApi